import useFetchData from '../../../../../hooks/fetchHook';

export const useGetUsersInolved = ({ ticketId }) => {
  const [{ data = [] }] = useFetchData(
    `office_support_ticket/${ticketId}/people`,
    {
      formatter: formatUsersInvolved,
      failureFormatter: () => [],
    }
  );

  return { data };
};

const formatUsersInvolved = users => {
  return users.map(user => {
    const { usImage: image, usDisplayName: name } = user;
    return {
      image,
      name,
    };
  });
};
